var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 63,
    viewBox: "0 0 65 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6371_14508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7739 19.8447L31.2087 4L23.6435 19.8447L6.35156 22.3301L18.7029 34.6019L15.7695 52L31.2087 43.767L46.6479 52L43.7144 34.6019L56.0658 22.3301L38.7739 19.8447Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6484 19.8447L31.2136 4V13.2427L26.5617 22.9854L23.6484 19.8447Z",
    fill: "#F9AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2109 4L38.7761 19.8447L35.8628 22.9854L31.2109 13.2427V4Z",
    fill: "#FBDE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7727 19.8438L56.0646 22.3292L46.4923 24.5127L35.8594 22.9845L38.7727 19.8438Z",
    fill: "#FBDE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0657 22.3359L43.7143 34.6078L38.8984 32.0653L46.4934 24.5195L56.0657 22.3359Z",
    fill: "#F9AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7143 34.605L46.6478 52.003L40.7022 42.7603L38.8984 32.0625L43.7143 34.605Z",
    fill: "#FBDE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6501 52.0004L31.2109 43.7674V37.6953L40.7046 42.7577L46.6501 52.0004Z",
    fill: "#F9AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2126 43.7674L15.7734 52.0004L21.719 42.7577L31.2126 37.6953V43.7674Z",
    fill: "#F9AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7734 52.003L18.7069 34.605L23.5228 32.0625L21.719 42.7603L15.7734 52.003Z",
    fill: "#FBDE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7029 34.6078L6.35156 22.3359L15.9239 24.5195L23.5188 32.0653L18.7029 34.6078Z",
    fill: "#F9AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35156 22.3292L23.6435 19.8438L26.5568 22.9845L15.9239 24.5127L6.35156 22.3292Z",
    fill: "#FBDE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8664 22.9849L31.2145 13.2422L26.5626 22.9849L15.9297 24.5131L23.5246 32.0589L21.7208 42.7567L31.2145 37.6944L40.7082 42.7567L38.9044 32.0589L46.4993 24.5131L35.8664 22.9849Z",
    fill: "#FCC853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8664 22.9849L31.2145 13.2422L26.5626 22.9849L15.9297 24.5131L23.5246 32.0589L21.7208 42.7567L31.2145 37.6944L40.7082 42.7567L38.9044 32.0589L46.4993 24.5131L35.8664 22.9849ZM44.5197 25.1701L35.2456 23.8371L31.2145 15.3946L27.1834 23.8371L17.9093 25.1701L24.5186 31.7365L22.9487 41.0472L31.2145 36.6395L39.4803 41.0472L37.9104 31.7365L44.5197 25.1701Z",
    fill: "#FFEF9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6371_14508",
    x: 0.351562,
    y: 0.428572,
    width: 63.7109,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6371_14508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6371_14508",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIco);
export default __webpack_public_path__ + "static/media/StarIco.d58da7651722cdda7792ab8f25e23bee.svg";
export { ForwardRef as ReactComponent };